var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sticky z-10 top-0 w-full bg-white"},[_c('div',{staticClass:"w-full h-2 bg-core bg-opacity-16"},[_c('div',{staticClass:"h-full bg-core transition-all duration-500 ease-out",style:({ width: `${_vm.percentage}%` })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }